<template>
	<div class="lg:px-8 mx-auto px-4 sm:px-68" :class="fixedWidthHeader ? 'max-w-7xl' : ''">
		<div class="flex items-center h-16">
			<div class="flex items-center">
				<!-- SlideCub logo --->
				<Link href="/" class="flex">
					<ApplicationLogo />
				</Link>
			</div>

			<div class="flex justify-between w-full">

				<!-- Page Navigation -->
				<div class="block ml-8">
					<div class="flex space-x-4">
						<Link data-heap="click-icons-header" href="/icons/heroicons" class="font-medium px-3 py-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-bg-gray-600 text-sm"
								:class="[$page.component === 'Homepage/NewIconListHeader' ? 'bg-indigo-50 border-indigo-500 text-indigo-800' : 'text-gray-600 bg-white']"
						>Icons</Link>

						<Link data-heap="click-repository-header" href="/repository" class="font-medium px-3 py-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-bg-gray-600 text-sm"
							  :class="[$page.component === 'SlideRepo/SlideRepository' ? 'bg-indigo-50 border-indigo-500 text-indigo-800' : 'text-gray-600 bg-white']"
						>Slide Repository</Link>

						<Link data-heap="click-ai-slide-review" href="/" class="font-medium px-3 py-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-bg-gray-600 text-sm"
						>AI Presentation Review</Link>

<!--						<div class="font-medium px-3 py-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-bg-gray-600 text-sm cursor-not-allowed"-->
<!--							  :class="[$page.component === 'Templates' ? 'bg-indigo-50 border-indigo-500 text-indigo-800' : 'text-gray-600 bg-white']"-->
<!--						>Templates</div>-->

					</div>
				</div>


				<div class="hidden md:block sm:ml-8">
					<div v-if="!auth.user?.email" class="flex space-x-4">
						<Link data-heap="login-header" href="/login" class="font-medium px-3 py-2 rounded-md text-gray-600 hover:text-gray-600 text-sm">Login</Link>
						<Link data-heap="register-header" href="/register" class="border font-medium px-3 py-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-bg-gray-600 text-sm">Create Account</Link>
					</div>

					<div v-else class="flex items-center space-x-4">
						<Link data-heap="click-team-management" href="/team-management" class="flex items-center font-medium px-3 py-2 text-gray-400 hover:text-gray-700 text-sm border rounded-full hover:bg-gray-100">

							<img v-if="!isPersonalTeam" :src="'https://www.google.com/s2/favicons?domain=' + auth.user.current_team.domain + '&sz=128'" class="h-4 mr-2" >

							<span class="pr-2">{{ calcTeamName }}</span>

							<!-- On trial -->
							<p v-if="auth.user?.onTrial" class="bg-slate-100 border-gray-200 inline-flex leading-5 px-2 rounded-full shadow text-fuchsia-700 font-bold text-xs">
								{{ "On Trial"}}
							</p>

							<!-- Is Premium subscribed --->
							<p v-if="!auth.user?.onTrial && auth.user?.is_premium_user" class="bg-slate-100 border-gray-200 inline-flex leading-5 px-2 rounded-full shadow text-fuchsia-700 font-bold text-xs">
								<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" class="h-5 text-fuchsia-800 w-4" viewBox="0 0 256 256"><g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"><path d="M78.52 77.62H11.48a2 2 0 0 1-1.96-1.6L.04 29.54a2 2 0 0 1 3-2.11l25.58 15.42L43.2 13.49a2 2 0 0 1 1.77-1.1c.71-.01 1.45.4 1.8 1.07l15.07 29.1 25.12-15.13a2 2 0 0 1 3 2.11l-9.5 46.48a2 2 0 0 1-1.95 1.6z" transform="matrix(2.81 0 0 2.81 1.4 1.4)" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentcolor; fill-rule: nonzero; opacity: 1;"></path></g></svg>
							</p>

							<!-- Expired -->
							<p v-if="!auth.user?.onTrial && !auth.user?.is_premium_user" class="bg-slate-100 border-gray-200 inline-flex leading-5 px-2 rounded-full shadow text-red-600 font-bold text-xs">
								No Subscription
							</p>


						</Link>


						<!-- Profile dropdown -->
						<Menu as="div" class="relative ml-3 ">
							<div class="">
								<MenuButton data-heap="click-profile-picture" class="relative flex rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
									<span class="absolute -inset-1.5" />
									<span class="sr-only">Open user menu</span>
									<span>
										<img v-if="auth.user?.photoLink" :src="auth.user?.photoLink" class="h-8 w-8 rounded-full border">
										<span v-else class="size-[38px] border rounded-full bg-gray-200 text-gray-600 flex justify-center items-center">{{ auth.user?.name.charAt(0).toUpperCase() }}</span>
									</span>
								</MenuButton>
							</div>
							<transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
								<MenuItems class="absolute right-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white pb-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
									<div class="block px-4 py-2 text-xs text-gray-600 bg-gray-100 border-b">
										<span v-if="auth.user?.name !== auth.user?.email">
											{{ auth.user?.name }}
										</span>
										{{ auth.user?.email }}
									</div>

									<MenuItem v-slot="{ active }">
										<Link data-heap="click-profile-from-dropdown" href="/profile" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">Your Profile</Link>
									</MenuItem>
									<MenuItem v-slot="{ active }">
										<Link data-heap="click-team-from-dropdown" href="/team-management" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">Your Team</Link>
									</MenuItem>
									<MenuItem v-slot="{ active }">
										<Link data-heap="logout-from-dropdown" href="/logout" method="POST" as="button" @click="heap.resetIdentity()" class="w-full text-left" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">Logout</Link>
									</MenuItem>
								</MenuItems>
							</transition>
						</Menu>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script setup>
import {Link, usePage} from '@inertiajs/vue3'
import {computed, onMounted, ref} from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import ApplicationLogo from "@/Components/ApplicationLogo.vue";

const props = defineProps({
	auth: {type: Object},
	fixedWidthHeader: {type: Boolean, default: true}
});

const isPersonalTeam = ref(false);

const calcTeamName = computed(() => {
	if(props.auth.user?.current_team) { // if there is a team
		// and if that team name is "Personal"
		if(props.auth.user?.current_team.type === 'personal') {
			isPersonalTeam.value = true;
			return 'Personal Account';
		} else {
			return props.auth.user?.current_team.name
		}
	} else {
		isPersonalTeam.value = true;
		return 'Join/ Create Team'
	}
});
const page = usePage();

onMounted(() => {

	if (page.props.auth.auth_provider) {
		localStorage.setItem('lastUsed', page.props.auth.auth_provider); // helps remind users on login
	}
});

</script>
